import { Injectable, inject } from '@angular/core';
import { AuthenticationService } from 'app/services/auth.service';

@Injectable()
export class AccountantGuard {
  private auth = inject(AuthenticationService);

  canMatch() {
    return this.auth.user?.isAccountant === true;
  }
}
